'use strict';

// Simple CommonJS export, but Webpack configuration can exports it to 3 formats:
//  - CommonJS
//  - AMD
//  - typical global variable
module.exports = require('is-url');



//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 0
// module chunks = 0 1